import { gql } from '@apollo/client'
import { STORE_FRAGMENT } from './StoreFragment'

export const DISPLAY_WITH_STORE_DATA_FRAGMENT = gql`
  fragment DisplayWithStoreData on Display {
    id
    created
    name
    shortDescription
    displayType
    extraInfo
    saved
    isCompetitor
    salesVolume
    images {
      id
      url
    }
    area
    numCoolerDoors
    doorHandlePlacement
    idealInventory {
      upcs
    }
    latestRecommendations {
      id
      created
      score
      productRecommendations {
        count
        upc
      }
    }
    point {
      latitude
      longitude
    }
    dateRemoved
    movedToDisplay {
      id
    }
    previousAuditUpcs
    merchandisingState
    needsFieldVerifiedCountsPostScan
    needsFieldVerifiedCountsPreScan
    store {
      ...Store
      company {
        id
      }
    }
  }
  ${STORE_FRAGMENT}
`
